import MembershipStatusModelBase from '../_generated/modelBases/membership-status-model-base';

export default class MembershipStatusModel extends MembershipStatusModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
